import React from 'react';
import { BoxIcon } from 'lucide-react';
interface SolutionCardProps {
  title: string;
  description: string;
  icon: BoxIcon;
  linkText?: string;
  onClick?: () => void;
}
export function SolutionCard({
  title,
  description,
  icon: Icon,
  linkText = 'Get Started >',
  onClick
}: SolutionCardProps) {
  return <div onClick={onClick} className="flex items-start p-6 rounded-xl bg-white border border-gray-200 shadow-sm hover:shadow-md hover:border-blue-200 transition-all group cursor-pointer" data-id="element-272">
      <div className="flex-shrink-0 mr-6" data-id="element-273">
        <div className="w-14 h-14 rounded-lg bg-blue-50 flex items-center justify-center group-hover:bg-[#0B5FA5] transition-colors" data-id="element-274">
          <Icon className="w-7 h-7 text-[#0B5FA5] group-hover:text-white transition-colors stroke-[1.5]" data-id="element-275" />
        </div>
      </div>
      <div data-id="element-276">
        <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-[#0B5FA5] transition-colors" data-id="element-277">
          {title}
        </h3>
        <p className="text-sm text-gray-600 mb-4 leading-relaxed" data-id="element-278">
          {description}
        </p>
        <span className="text-sm font-semibold text-[#0B5FA5] flex items-center" data-id="element-279">
          {linkText}
        </span>
      </div>
    </div>;
}